import { useTranslation } from 'react-i18next';
import { SxProps, TableCell, TableRow, Typography } from '@mui/material';

interface CountryInfoTableRowData {
  targetGroup?: string;
  campaignScenario?: string;
  segments?: { id: string; name: string }[];
  startDate?: string;
  campaignLength?: string;
}

interface BudgetTableRowProps {
  rowData: CountryInfoTableRowData;
  sx?: SxProps;
}

function CountryInfoRow({ rowData, sx }: BudgetTableRowProps) {
  const { t } = useTranslation();

  return (
    <TableRow sx={{ borderBottom: 'none', height: '70px', ...sx }}>
      <TableCell />
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700} textTransform="uppercase">
          {rowData.targetGroup}
        </Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700}>
          {rowData.campaignScenario}
        </Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700}>
          {rowData.segments && rowData.segments.length > 0
            ? rowData.segments.map((segment) => segment.name).join(', ')
            : '-'}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={700}>
          {rowData.startDate}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={700}>
          {`${rowData.campaignLength} weeks`}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default CountryInfoRow;
